import Image from 'next/image';
import './FullBody.css';

const FullBody = ({ children, beforeContent, afterContent }) => {
  return (
    <div className="full-body">
      {/* Background image */}
      <div className="background-image">
        <Image
          src="/assets/body.webp"
          alt="Background"
          fill
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
          }}
          priority
        />
      </div>

      {/* Gradient overlay */}
      <div className="overlay"></div>

      {/* Content */}
      <div className="content">
        {beforeContent} {/* Optional Dynamic Part */}
        {children} {/* Main Page Content */}
        {afterContent} {/* Optional Dynamic Part */}
      </div>
    </div>
  );
};

export default FullBody;
